import React, { useState } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  InputBase,
  Paper,
  Divider
} from '@mui/material';
import "./shareButton.css";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useLocation } from "react-router-dom";
import { generateEventoUrl } from '../../utils/generateEventoUrl';
import { X, WhatsApp, Facebook, Close, ShareOutlined } from '@mui/icons-material';

const ShareButton = ({ idEvento, eventoNombre, ...props }) => {
  const [open, setOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const location = useLocation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => { setOpen(false); setCopySuccess(false); };

  const currentPath = `https://passgo.com.ar${generateEventoUrl({ id: idEvento, evento: eventoNombre })}`;
  const urlCodificada = encodeURIComponent(currentPath);

  const shareMessage = encodeURIComponent(
    "Hey! Mira este evento.. " + currentPath
  );

  const vistaEventoInformacion = location.pathname.includes('/e/');

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentPath);
    setCopySuccess(true);
  };

  return (
    <>
      <IconButton
        className={`${vistaEventoInformacion ? 'button-special' : 'button-share'}`}
        onClick={handleOpen}
      >
        <ShareOutlined className={`${vistaEventoInformacion ? 'button-special' : 'button-share'}`} {...props} />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '10px',
          }
        }}
      >
        <DialogTitle sx={{ marginBottom: "8px" }}>
          <Typography sx={{ fontSize: "18px" }} align="center" fontWeight={600}>
            Compartir evento
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            sx={{
              position: 'absolute',
              /* right: 8, */
              top: 8 
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{padding:"20px !important"}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-around', mb: 3, }}>
            <Box
              component="a"
              href={`https://www.facebook.com/sharer/sharer.php?u=${urlCodificada}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                '&:hover': { textDecoration: 'none', color: '#1877F2' }
              }}
            >
              <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "center", width: 50, height: 50, mb: 1, borderRadius: '100%', backgroundColor: "#E6E6FF" }}>
                <Facebook sx={{ fontSize: "28px" }} />
              </Box>
              <Typography variant="body2">Facebook</Typography>
            </Box>

            <Box
              component="a"
              href={`https://api.whatsapp.com/send?text=` + shareMessage}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                '&:hover': { textDecoration: 'none', color: '#25D366' }
              }}
            >
              <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "center", width: 50, height: 50, mb: 1, borderRadius: '100%', backgroundColor: "#E6E6FF" }}>
                <WhatsApp sx={{ fontSize: "28px" }} />
              </Box>
              <Typography variant="body2">WhatsApp</Typography>
            </Box>

            <Box
              component="a"
              href={`https://x.com/intent/tweet?url=${urlCodificada}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                '&:hover': { color: '#1DA1F2', textDecoration: "none" }
              }}
            >
              <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "center", width: 50, height: 50, mb: 1, borderRadius: '100%', backgroundColor: "#E6E6FF" }}>
                <X />
              </Box>
              <Typography variant="body2">Twitter</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography sx={{ mb: 1, fontSize: "14px" }}>
            O copia el enlace:
          </Typography>

          <Paper
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
            variant="outlined"
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              value={currentPath}
              readOnly
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton
              color="primary"
              sx={{ p: '10px' }}
              onClick={handleCopyLink}
            >
              <ContentCopyIcon sx={{ color: "rgb(86, 86, 255)" }} />
            </IconButton>
          </Paper>

          {copySuccess && (
            <p style={{ marginTop: "12px", marginBottom: "4px !important", color: "rgb(86, 86, 255)", textAlign: "center" }}>¡Enlace copiado correctamente!</p>
          )}

        </DialogContent>
      </Dialog>
    </>
  );
};

export default ShareButton;
